export const SET_CURRENCIES='currencies:set-currencies';
export const FETCH_CURRENCIES='currencies:fetch-currencies';
export const FETCH_CURRENCIES_SUCCESS='currencies:fetch-currencies-success';
export const FETCH_CURRENCIES_FAIL='currencies:fetch-currencies-fail';
export const ERROR_CURRENCIES='currencies:error-currencies';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/currencies/action-types.js
 **/